/*
 * Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import {Injectable} from '@angular/core';
import {EnvironmentService} from "@irian-ro/util-environment";
import { HttpClient } from '@angular/common/http';
import {Observable} from 'rxjs';
import { AbstractResourceService, JsonApiListResourceMetadataBase, QueryParams } from '@irian-ro/abstract-resource';
import { PackageVoModel } from '@well/delivery-libs/packages/domain';

@Injectable({
  providedIn: 'root'
})
export class ShipmentPackagesResourceService extends AbstractResourceService<PackageVoModel, any, JsonApiListResourceMetadataBase, any > {

  constructor(httpClient: HttpClient, environmentService: EnvironmentService) {
    super(
      httpClient,
      `${environmentService.getEnvironmentProperty('shipmentPackagesUrl')}`,
      PackageVoModel
    );
  }

  findAllPackages(shipmentBaseUuid, query?: any,
                  additionalParams?: any): Observable<PackageVoModel[]> {
    const queryString = new QueryParams(
      query,
      additionalParams ? additionalParams : []).toString();

    return <Observable<PackageVoModel[]>>this.httpClient?.get(`${this.url}/${shipmentBaseUuid}${queryString}`);
  }

}
